import React from 'react';
import './AdminTd.css';

/**
 * @param {{
 *   children?: React.ReactNode,
 *   className?: string
 * } & React.TdHTMLAttributes<HTMLTableCellElement>} props
 */
function AdminTd({ children, className = '', ...rest }) {
  return (
    <td className={`au-td au-scope${className ? ` ${className}` : ''}`} {...rest}>
      {children}
    </td>
  );
}

export default AdminTd;
